<template>
  <div class="layout px-0">
    <v-btn icon class="mx-1">
      <v-icon color="teal" @click="onEdit()">edit</v-icon>
    </v-btn>
    <v-btn icon class="mx-1">
      <v-icon color="red" @click="onDelete()">delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  data: () => ({}),
  methods: {
    onEdit() {
      this.params.onEdit(this.params.data);
    },
    onDelete() {
      this.params.onDelete(this.params.data);
    },
  },
});
</script>